<div class="p-gutter">
  <div class="card p-3">
    <h4 class="text-center">{{ mode === 'review' ? 'Review Essay Examination' : 'Mark Essay Examination' }} for
      {{examination.examinationName}}</h4>

    <div class="row">

      <!-- Statistics information -->
      <div *ngIf="mode === 'mark'">
        <small class="text-muted   fw-bold">No. of candidates assigned: {{candidateCount}} | </small>
        <small class="text-muted  fw-bold">Marked: {{totalMarkedCandidates}} | </small>
        <small class="text-muted  fw-bold">Unmarked: {{totalUnMarkedCandidates}} </small>
      </div>
      <div *ngIf="mode === 'review' ">
        <small class="text-muted  fw-bold">Total No. Candidates: {{candidateCount}} | </small>
        <small class="text-muted  fw-bold">No. assigned: {{candidates.length}} | </small>
        <small class="text-muted  fw-bold">Reviewed: {{totalCandidatesReviewed}} | </small>
        <small class="text-muted  fw-bold">Pending: {{totalCandidatesPending}} </small>
      </div>

      <!-- Candidates List -->
      <div class="col-md-3 candidatesdiv" style="max-height: 80vh; overflow-y: auto;">
        <div *ngFor="let cand of candidates">
          <button [ngClass]="{
                  'btn-success': (mode != 'review' ? cand.marked : cand.reviewed), 
                  'btn-primary': (mode != 'review' ? !cand.marked : !cand.reviewed)
                }" class="p-2 btn w-100 text-center mb-1 canlist" [id]="cand.examNo" (click)="loadAllQuestions(cand)">
            <div class="d-flex flex-column">
              <div>
                {{cand.examNo}}
                <span *ngIf="cand.marked && mode != 'review'"> Marked <mat-icon class="mat-icon-button icon-sm "
                    svgIcon="mat:check_circle" title="Marked" style="font-size: x-small;"></mat-icon>
                </span>
                <span *ngIf="cand.reviewed && mode === 'review'"> Reviewed <mat-icon class="mat-icon-button icon-sm "
                    svgIcon="mat:check_circle" title="Reviewed" style="font-size: x-small;"></mat-icon>
                </span>
              </div>
              <div class="d-flex flex-column" *ngIf="cand.marked && mode === 'review'">
                <small *ngIf="cand.marked && cand.examiner">Marked by: {{cand.examiner}}</small>
                <small *ngIf="cand.reviewed && cand.reviewer">Reviewed by: {{cand.reviewer}}</small>
              </div>
            </div>
          </button>
        </div>
      </div>

      <!-- Examination Content -->
      <div class="col-md-9" style="max-height: 90vh; overflow-y: auto;">
        <div class="card p-5 d-flex justify-content-center align-items-center text-center"
          *ngIf="selectedCandidate && (questions?.length === 0)">
          <h4 class="text-muted">No question was answered by candidate</h4>
        </div>
        <div class="card p-3" *ngIf="pickedQuestion">
          <div *ngIf="mode != 'review' && selectedCandidate?.marked" class="alert alert-warning mt-1">
            <strong class="text-muted">
              This essay has already been graded and is no longer eligible for re-evaluation.
            </strong>
          </div>

          <div class="d-flex align-items-center mb-3">
            <div class="badge bg-primary p-2">Candidate Number: {{selectedCandidate.examNo}}</div>
          </div>

          <!-- Question Navigation -->
          <div class="mb-2">
            <h6>Questions:</h6>
            <div class="btn-group" role="group" *ngIf="questions.length > 0">
              <button *ngFor="let question of questions;" class="btn btn-outline-secondary"
                [ngClass]="{'btn-secondary text-white': question.esqId == pickedQuestion.esqId}"
                (click)="loadQuestion(question.esqId)">
                {{question.questionNo}}
              </button>
            </div>
          </div>

          <!-- Question Content -->
          <div class="card p-3">
            <h5>Question {{pickedQuestion.questionNo}}</h5>
            <div style="height: 200px; overflow-y: auto;" class="bg-light p-3 rounded mb-3"
              [innerHTML]="pickedQuestion.question">
            </div>
            <ng-container *ngIf="!pickedQuestion.hasEssaySubQuestions">
              <h6>Candidate's Answer:</h6>
              <div class="form-control border-box p-3" style="min-height: 200px;"
                [innerHTML]="pickedQuestion.candidateAnswer | safeHtml"></div>

            </ng-container>
            <div class="d-flex justify-content-between mt-1">
              <span class="badge bg-secondary p-2">Marks Obtainable: {{pickedQuestion.mark}}</span>
              <span class="badge bg-secondary p-2">Max Word Count: {{pickedQuestion.maxWordCount}}</span>
            </div>

            <!-- Scoring Section -->
            <div class="card p-3 mt-3 bg-light">
              <!-- Standard  Scoring -->
              <div class="row align-items-center" *ngIf="!pickedQuestion.hasEssaySubQuestions">
                <div class="col-md-2">
                  <label for="mark" class="form-label mb-0">Score:</label>
                </div>
                <div class="col-md-7">
                  <input type="number" min="0" class="form-control" id="mark"
                    [(ngModel)]="pickedQuestion.essayMarkEarned" [ngModelOptions]="{ standalone: true }"
                    [readonly]="mode === 'review' || (mode === 'mark' && selectedCandidate?.marked)">
                </div>
                <div class="col-md-3 text-end">
                  <button *ngIf="mode != 'review' && !selectedCandidate?.marked" class="btn btn-dark"
                    [disabled]="selectedCandidate?.marked" (click)="markEssay()">
                    Save Score
                  </button>
                  <button *ngIf="mode === 'review'" class="btn btn-warning" (click)="openAdjustScoreModal()">
                    Adjust Score
                  </button>
                </div>
              </div>

              <!-- Question Sub-Question Scoring -->
              <div *ngIf="pickedQuestion.hasEssaySubQuestions">
                <h5 class="mb-4 fw-semibold text-dark">Question Sub-Question Scoring</h5>

                <div *ngFor="let subQuestion of pickedQuestion.scheduleEssaySubQuestions; let i = index"
                  class="card mb-4 border">

                  <!-- Sub-Question Header -->
                  <div class="card-header d-flex justify-content-between align-items-center" [ngClass]="{ 
    'bg-light': i % 2 === 0, 
    'bg-white': i % 2 !== 0 
  }">
                    <strong class="text-dark">Question {{ pickedQuestion.questionNo }}{{ subQuestion.questionNoLabel
                      }}</strong>
                    <span class="text-muted small">{{ subQuestion.marks }} marks</span>
                  </div>

                  <div class="card-body bg-white">

                    <!-- Question Content -->
                    <div class="mb-3">
                      <h6 class="fw-semibold mb-2">Question</h6>
                      <div style="height: 100px; overflow-y: auto;" class="bg-light p-3 rounded mb-3"
                        [innerHTML]="subQuestion.questionHtml">
                      </div>
                    </div>

                    <!-- Candidate Answer -->
                    <div class="mb-3">
                      <h6 class="fw-semibold mb-2">Candidate's Answer</h6>
                      <div class="border rounded p-3 bg-white"
                        style="min-height: 150px; max-height: 300px; overflow-y: auto;"
                        [innerHTML]="subQuestion.candidateAnswer | safeHtml"></div>
                    </div>

                    <!-- Score Input -->
                    <div>
                      <h6 class="fw-semibold mb-2">Score for Sub-Question {{ subQuestion.questionNoLabel }}</h6>
                      <div class="row align-items-center gy-2">
                        <div class="col-md-4">
                          <label [for]="'subQuestion-score-' + i" class="form-label mb-0 fw-semibold">
                            Enter Score:
                          </label>
                        </div>
                        <div class="col-md-5">
                          <div class="input-group">
                            <input type="number" min="0" class="form-control" [id]="'subQuestion-score-' + i"
                              [(ngModel)]="subQuestion.essayMarkEarned" [readonly]="isReadOnly()"
                              [max]="subQuestion.marks" min="0" step="0.5" placeholder="Score"
                              [ngModelOptions]="{ standalone: true }" aria-label="Sub-Question score" />
                            <span class="input-group-text">/ {{ subQuestion.marks }}</span>
                          </div>
                        </div>
                        <div class="col-md-3 text-muted small">
                          Max: {{ subQuestion.marks }} marks
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

                <!-- Total Score Summary -->
                <div class="alert mt-4 py-3 px-4" [ngClass]="{
      'alert-danger': totalScheduleEssaySubQuestionScores > pickedQuestion.mark,
      'alert-success': totalScheduleEssaySubQuestionScores <= pickedQuestion.mark && totalScheduleEssaySubQuestionScores > 0,
      'alert-secondary': totalScheduleEssaySubQuestionScores === 0
    }">
                  <div class="d-flex justify-content-between align-items-center">
                    <h6 class="mb-0">Total Question Score:</h6>
                    <h5 class="mb-0 fw-bold">{{ totalScheduleEssaySubQuestionScores }} / {{ pickedQuestion.mark }}</h5>
                  </div>
                  <div *ngIf="totalScheduleEssaySubQuestionScores > pickedQuestion.mark" class="text-danger mt-2">
                    Total scores exceed the maximum mark for this question!
                  </div>
                </div>

                <!-- Save / Adjust Buttons -->
                <div class="text-center mt-3">
                  <button *ngIf="mode !== 'review' && !selectedCandidate?.marked" class="btn btn-dark px-4"
                    [disabled]="selectedCandidate?.marked" (click)="markEssay()">
                    Save Scores
                  </button>
                  <button *ngIf="mode === 'review' && selectedCandidate?.marked" class="btn btn-outline-dark px-4"
                    (click)="openAdjustScoreModal()">
                    Adjust Score
                  </button>
                </div>
              </div>


            </div>

            <!-- Question Navigation -->
            <div class="d-flex justify-content-between mt-2">
              <button class="btn btn-sm  btn-outline-primary" (click)="previousQuestion()"
                [disabled]="!hasPreviousQuestion()">Previous
                Question</button>
              <button class="btn btn-sm btn-outline-primary" (click)="nextQuestion()"
                [disabled]="!hasNextQuestion()">Next Question</button>
            </div>

            <div *ngIf="mode !== 'review' && !selectedCandidate?.marked" class="d-flex justify-content-center mt-1">
              <button class="btn btn-danger" (click)="openSubmitConfirmation($event)"
                [disabled]="!selectedCandidate || selectedCandidate.marked">Submit Assessment</button>
            </div>

            <div *ngIf="mode === 'review' && !selectedCandidate?.reviewed" class="d-flex justify-content-center mt-1">
              <button class="btn btn-primary" (click)="SetAsReviewed()">Submit Review</button>
            </div>

            <div class="alert alert-info py-2 mt-3">
              <h5>Total Overall Score: {{totalScore}}</h5>
            </div>

            <!-- Question Navigation -->
            <div class="mt-1">
              <h6>Questions:</h6>
              <div class="btn-group" role="group" *ngIf="questions.length > 0">
                <button *ngFor="let question of questions;" class="btn btn-outline-secondary"
                  [ngClass]="{'btn-secondary text-white': question.esqId == pickedQuestion.esqId}"
                  (click)="loadQuestion(question.esqId)">
                  {{question.questionNo}}
                </button>
              </div>
            </div>

            <!-- Candidate Navigation -->
            <div class="d-flex justify-content-between mt-3">
              <button class="btn btn-primary" [disabled]="!hasPreviousCandidate()"
                (click)="previousCandidate()">Previous
                Candidate</button>
              <button class="btn btn-primary" [disabled]="!hasNextCandidate()" (click)="nextCandidate()">Next
                Candidate</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>